import { render, staticRenderFns } from "./addTenantDialog.vue?vue&type=template&id=64df6e49"
import script from "./addTenantDialog.vue?vue&type=script&lang=js"
export * from "./addTenantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports